(() => {
  if (window.NatLeanCart) return;

  const root = window.Shopify?.routes?.root || '/';
  let quantityTimer;
  let refreshTimer;
  let activeRequest;

  const drawer = () => document.getElementById('cart-drawer');
  const panel = () => drawer()?.querySelector(':scope > dialog[ref="panel"]');

  function syncCartCount(count) {
    const safeCount = Math.max(0, Number(count) || 0);

    for (const icon of document.querySelectorAll('cart-icon')) {
      if (typeof icon.renderCartBubble === 'function') {
        icon.renderCartBubble(safeCount, false, false);
        continue;
      }

      const bubble = icon.querySelector('.cart-bubble');
      const bubbleCount = icon.querySelector('.cart-bubble__text-count');
      bubble?.classList.toggle('visually-hidden', safeCount === 0);
      bubbleCount?.classList.toggle('hidden', safeCount === 0);
      if (bubbleCount) bubbleCount.textContent = safeCount < 100 ? String(safeCount) : '';
    }

    sessionStorage.setItem('cart-count', JSON.stringify({ value: String(safeCount), timestamp: Date.now() }));
  }

  function applyDrawerHTML(html) {
    if (!html) return;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const nextInner = parsed.querySelector('.cart-drawer__inner');
    const currentInner = drawer()?.querySelector('.cart-drawer__inner');
    if (nextInner && currentInner) currentInner.replaceWith(nextInner);
  }

  function applyCartPageHTML(html) {
    if (!html) return;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const nextSection = parsed.getElementById('shopify-section-cart-section');
    const currentSection = document.getElementById('shopify-section-cart-section');
    if (nextSection && currentSection) currentSection.replaceWith(nextSection);
  }

  function openDrawer() {
    const element = drawer();
    const dialog = panel();
    if (!element || !(dialog instanceof HTMLDialogElement)) return false;

    if (typeof element.open === 'function') {
      if (element.hasAttribute('open') && !dialog.open) element.removeAttribute('open');
      element.open();
      return true;
    }

    element.setAttribute('open', '');
    if (!dialog.open) dialog.showModal();
    return true;
  }

  function closeDrawer() {
    const element = drawer();
    const dialog = panel();
    if (!element) return;

    if (typeof element.close === 'function') {
      element.close();
      return;
    }

    if (dialog instanceof HTMLDialogElement && dialog.open) dialog.close();
    element.removeAttribute('open');
    document.documentElement.removeAttribute('scroll-lock');
  }

  async function requestCartSections(line, quantity) {
    activeRequest?.abort();
    activeRequest = new AbortController();

    const sections = ['cart-drawer-section'];
    if (document.getElementById('shopify-section-cart-section')) sections.push('cart-section');

    const requestBody = {
      sections: sections.join(','),
      sections_url: window.location.pathname,
    };
    if (line != null) {
      requestBody.line = line;
      requestBody.quantity = quantity;
    } else {
      requestBody.updates = {};
    }

    const endpoint = line == null ? `${root}cart/update.js` : `${root}cart/change.js`;
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(requestBody),
      signal: activeRequest.signal,
    });
    const cart = await response.json();

    if (!response.ok || cart.errors) {
      throw new Error(cart.description || cart.message || 'Unable to update cart');
    }

    applyDrawerHTML(cart.sections?.['cart-drawer-section']);
    applyCartPageHTML(cart.sections?.['cart-section']);
    syncCartCount(cart.item_count);
    return cart;
  }

  async function refresh({ open = false } = {}) {
    try {
      const cart = await requestCartSections();
      if (open) requestAnimationFrame(openDrawer);
      return cart;
    } catch (error) {
      if (error?.name !== 'AbortError') console.error('[NatLean cart]', error);
      return null;
    }
  }

  function scheduleRefreshAndOpen() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(() => refresh({ open: true }), 40);
  }

  document.addEventListener(
    'quantity-selector:update',
    (event) => {
      if (!(event.target instanceof Element) || !event.target.closest('#cart-drawer')) return;

      const line = Number(event.detail?.cartLine);
      const quantity = Number(event.detail?.quantity);
      if (!line || !Number.isFinite(quantity)) return;

      event.stopImmediatePropagation();
      window.clearTimeout(quantityTimer);
      quantityTimer = window.setTimeout(async () => {
        try {
          await requestCartSections(line, quantity);
        } catch (error) {
          if (error?.name !== 'AbortError') {
            console.error('[NatLean cart quantity]', error);
            await refresh();
          }
        }
      }, 180);
    },
    true
  );

  document.addEventListener('cart:update', (event) => {
    if (
      event.detail?.data?.source === 'product-form-component' &&
      !event.detail?.data?.managedByNatLeanCart
    ) {
      scheduleRefreshAndOpen();
    }
  });

  document.addEventListener('shopify:cart:lines-update', (event) => {
    const action = event.action || event.detail?.action;
    if (action !== 'add') return;

    const result = event.promise || event.detail?.promise;
    if (result && typeof result.then === 'function') {
      result.then(scheduleRefreshAndOpen).catch((error) => console.error('[NatLean cart add]', error));
    }
  });

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      if (event.target.closest('#cart-drawer .theme-drawer__close-button')) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      const dialog = panel();
      if (dialog instanceof HTMLDialogElement && event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        const outside =
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom;
        if (outside) closeDrawer();
      }
    },
    true
  );

  window.NatLeanCart = { open: openDrawer, close: closeDrawer, refresh };
})();
